import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Modal, Row, Container, Col } from "react-bootstrap";
import { Title, TextColored } from "../typography";
import { ThemeContext } from "../../theming";
import Close from "../../assets/images/close.png";
import { IsotipoBlack } from "../../assets/icons/dashboard";
import "./style.css";
export const CustomModal = ({
  children,
  padding = true,
  icon,
  headerColor = "white",
  title,
  subtitle = null,
  size = "md",
  handleClose,
  show,
  backdrop,
}) => {
  const app = useContext(ThemeContext);
  const { body12 } = app.theme.font;
  const styleBody = {
    padding: padding ? "1rem" : "1rem 0px",
  };
  return (
    <Modal show={show} onHide={handleClose} size={size} backdrop={backdrop}>
      {headerColor !== "white" ? (
        <>
          <Modal.Header style={{ backgroundColor: headerColor }}>
            <Row>
              {handleClose ? (
                <img
                  style={{
                    position: "absolute",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  src={Close}
                  height={40}
                  alt="imagen"
                  onClick={handleClose}
                />
              ) : null}
            </Row>

            <Container fluid>
              <Row>
                {icon && <Col xs={size === "xl" ? 1 : 2}>{icon}</Col>}
                <Col xs={9}>
                  <Row>
                    <Modal.Title>{title}</Modal.Title>
                  </Row>
                  {subtitle && (
                    <Row>
                      <TextColored
                        size={body12}
                        className="d-block"
                        type="gray"
                      >
                        {subtitle}
                      </TextColored>
                    </Row>
                  )}
                </Col>
              </Row>
            </Container>
          </Modal.Header>
          <Modal.Body style={styleBody}>{children}</Modal.Body>
        </>
      ) : (
        <>
          <Modal.Header style={{ backgroundColor: headerColor }} closeButton={!!handleClose}>
            <Container fluid>
              <Row>
                {icon && <Col xs={size === "xl" ? 1 : 2}>{icon}</Col>}
                <Col>
                  <Row>
                    <Modal.Title>{title}</Modal.Title>
                  </Row>
                  {subtitle && (
                    <Row>
                      <TextColored
                        size={body12}
                        className="d-block"
                        type="gray"
                      >
                        {subtitle}
                      </TextColored>
                    </Row>
                  )}
                </Col>
              </Row>
            </Container>
          </Modal.Header>
          <Modal.Body style={styleBody}>{children}</Modal.Body>
        </>
      )}
    </Modal>
  );
};

CustomModal.propTypes = {
  // children: PropTypes.node.isRequired,
  // title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  // subtitle: PropTypes.string,
  icon: PropTypes.node,
  padding: PropTypes.bool,
};

export const ModalSuccess = ({
  size = "md",
  show,
  icon,
  handleClose,
  headerTitle = "Alerta",
  title = "",
  subtitle = "",
  message = "",
  message2 = null,
  messageLine = false,
}) => {
  return (
    <Modal show={show} onHide={handleClose} size={size}>
      <Modal.Header
        className="justify-content-between align-items-center"
        //closeButton
      >
        <Title title={headerTitle} subtitle="" pipe={false} />
        <button type="button" class="close" onClick={handleClose} style={{padding: "1rem"}}>
          <span aria-hidden="true" style={{    
            //float: "right",
            fontSize: "1.5rem",
            fontWeight: 700,
            lineHeight: 1,
            color: "#000",
            textShadow: "0 1px 0 #fff",
            //opacity: .5
          }}
            >×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row className="justify-content-center align-content-center">
            <Col xs={4}>{icon}</Col>
            <Col xs={8}>
              <Row className="justify-content-center">{title}</Row>
              <Row className="justify-content-center">{subtitle} </Row>
              {messageLine === true ? (
                <Row
                  style={{ fontSize: "20px", fontWeight: "600" }}
                  className="justify-content-center"
                >
                  {"¡Muchas Gracias!"}
                </Row>
              ) : (
                <></>
              )}
              {messageLine === false ? (
                <Row className="justify-content-center text-center">{message}</Row>
              ) : (
                <></>
              )}
            </Col>
          </Row>
          {messageLine !== false ? (
            <Row className="justify-content-center text-center">{message}</Row>
          ) : (
            <></>
          )}
          <Row>{message2}</Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export const ModalSuccess2 = ({
  headerColor = "white",
  iconHeader,
  size = "md",
  show,
  icon,
  handleClose,
  headerTitle = "Alerta",
  title = "",
  subtitle = "",
  message = "",
  messageLine = false,
}) => {
  return (
    <Modal show={show} onHide={handleClose} size={size}>
      <Modal.Header
        style={{ backgroundColor: headerColor }}
        className="justify-content-between align-items-center"
      >
        <Row>
          <img
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              cursor: "pointer",
            }}
            src={Close}
            height={40}
            alt="imagen"
            onClick={handleClose}
          />
        </Row>
        <Container fluid>
          <Row>
            {icon && <Col xs={size === "xl" ? 1 : 2}>{iconHeader}</Col>}
            <Col>
              <Row>
                <Modal.Title>{headerTitle}</Modal.Title>
              </Row>
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row className="justify-content-center align-content-center">
            <Col xs={8}>
              <Row className="justify-content-center">{icon}</Row>
              <Row className="justify-content-center mt-4">{title}</Row>
              <Row className="justify-content-center">{subtitle}</Row>
              {messageLine === true ? (
                <Row
                  style={{ fontSize: "20px", fontWeight: "600" }}
                  className="justify-content-center"
                >
                  {"¡Muchas Gracias!"}
                </Row>
              ) : (
                <></>
              )}
              {messageLine === false ? (
                <Row className="justify-content-center text-center">{message}</Row>
              ) : (
                <></>
              )}
            </Col>
          </Row>
          {messageLine !== false ? (
            <Row className="justify-content-center text-center">{message}</Row>
          ) : (
            <></>
          )}
        </Container>
      </Modal.Body>
    </Modal>
  );
};

ModalSuccess.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  icon: PropTypes.node,
  size: PropTypes.string,
  // title: PropTypes.string,
  // subtitle: PropTypes.string,
  // message: PropTypes.string,
};

export const ModalWebPagos = ({
  size = "md",
  show,
  icon,
  handleClose,
  headerTitle = "Alerta",
  title = "",
  subtitle = "",
  message = "",
  message2 = null,
  messageLine = false,
  ButtonTry = null
}) => {
  const app = useContext(ThemeContext);
  const { body12 } = app.theme.font;
  const brandYellow = app.theme.brandYellow;
  const brandBlack = app.theme.brandBlack;
  return (
    <Modal show={show} onHide={handleClose} size={size}>
      <Modal.Header
        className="justify-content-between align-items-center"
        style={{ backgroundColor : brandYellow}}
        //closeButton
      >
        <Col xs={10} className="d-flex">
          <Row>
          <IsotipoBlack />
          </Row>
          <Row>
        <Title title={headerTitle} subtitle="" pipe={false} />
          </Row>
        </Col>
        <button type="button" class="close-black" onClick={handleClose} style={{padding: "1rem"}}>
          <span aria-hidden="true" style={{    
            //float: "right",
            fontSize: "1.5rem",
            fontWeight: 700,
            lineHeight: 1,
            color: brandYellow,
            textShadow: `0 1px 0 ${brandYellow}`,
            //opacity: .5
          }}
            >×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row className="justify-content-center align-content-center">
            <Col xs={9}>
              <Row className="justify-content-center">{icon}</Row>
              <Row className="justify-content-center">{title}</Row>
              <Row className="justify-content-center">{subtitle} </Row>
              {messageLine === true ? (
                <Row
                  style={{ fontSize: "20px", fontWeight: "600" }}
                  className="justify-content-center"
                >
                  {"¡Muchas Gracias!"}
                </Row>
              ) : (
                <></>
              )}
              {messageLine === false ? (
                <Row className="justify-content-center text-center">{message}</Row>
              ) : (
                <></>
              )}
              {!!ButtonTry ? (
            <Row className="justify-content-center text-center mt-2">
              {<ButtonTry />}
            </Row>
          ):(
            <></>
          )}
            </Col>
          </Row>
          {messageLine !== false ? (
            <Row className="justify-content-center text-center">{message}</Row>
          ) : (
            <></>
          )}
          <Row >{message2}</Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};